import { WalkthroughStep } from '@shared/modals/Walkthrough/Walkthrough.modal'

import DesignedForDayTraders from './assets/DesignedForDayTraders.webp'
import LongerExpirationPeriods from './assets/LongerExpirationPeriods.webp'
import StartTradingWithLess from './assets/StartTradingWithLess.webp'
import TradeAtRealSpotPrices from './assets/TradeAtRealSpotPrices.webp'

const getBg = (url: string) => `#070202 url(${url})`

export const sqfWalkthrough: WalkthroughStep[] = [
  {
    key: 'SQF.banners.DesignedForDayTraders',
    background: getBg(DesignedForDayTraders),
  },
  {
    key: 'SQF.banners.LongerExpirationPeriods',
    background: getBg(LongerExpirationPeriods),
  },
  {
    key: 'SQF.banners.TradeAtRealSpotPrices',
    background: getBg(TradeAtRealSpotPrices),
  },
  {
    key: 'SQF.banners.StartTradingWithLess',
    background: getBg(StartTradingWithLess),
  },
]
